import { Button, Center, Stack, Text } from "@mantine/core";
import { useNavigator } from "@/routers/routes";

export function NotFound() {
  const { navigate } = useNavigator();
  return (
    <Center h="50vh">
      <Stack>
        <Text size="md" c="gray" ta="center">
          Sorry, there is nothing here.
          <br />
          You probably got a wrong link.
          <br />
          If you think this is an error, please contact us at{" "}
          <a href="mailto:support@woofapy.com">support@woofapy.com</a>
          <br />
        </Text>
        <Button variant="outline" onClick={() => navigate({ path: "/" })}>
          Click to go home
        </Button>
      </Stack>
    </Center>
  );
}
